import { render, staticRenderFns } from "./Speciality.vue?vue&type=template&id=1b6ba754&"
import script from "./Speciality.vue?vue&type=script&lang=ts&"
export * from "./Speciality.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b6ba754')) {
      api.createRecord('1b6ba754', component.options)
    } else {
      api.reload('1b6ba754', component.options)
    }
    module.hot.accept("./Speciality.vue?vue&type=template&id=1b6ba754&", function () {
      api.rerender('1b6ba754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/Speciality.vue"
export default component.exports